<template>
  <div class="form-login">
    <gkForm class="account-form" transition="gk-fade-up" ref="signinForm" name="signin" v-model="signinForm">
      <CellPhone
        color="underline"
        size="big"
        :trigger="['blur']"
        v-model="cellphone"
        @keyup.native.enter="submit"
        @country="handleChooseCountry"
      />

      <!-- 图片验证码 -->
      <template v-if="isImgCaptchaShow">
        <ImgCaptcha
          color="underline"
          size="big"
          v-model="captcha"
          :src="imgCaptchaUrl"
          @check="handleCheckCaptcha"
        />
      </template>

      <Captcha
        color="underline"
        size="big"
        :trigger="['blur']"
        tips="您的验证码已发送至手机"
        :disabled="isImgCaptchaShow && !captchaValid"
        @send="sendMobileCode"
        v-model="code"
        v-if="type === 1"
      />

      <Password
        color="underline"
        size="big"
        v-model="password"
        v-if="type === 2"
      />

      <div class="btns">
        <div class="forgot" @click="handleForgot" v-if="type == 2">
          忘记密码
        </div>
        <gkButton color="blue" size="large" useLock @click="submit">登录</gkButton>
        <template v-if="isPC || isInWeixin">
          <p>或</p>
          <gkButton class="wechat-btn" color="write" size="large" @click="wechatlogin">
            <i class="iconfont">&#xe63c;</i>
            微信扫码登录
          </gkButton>
        </template>
      </div>
    </gkForm>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import {signin as signinError} from '../../../utils/errorCode'
import utils from '../../../utils'
import config from '../../../config'
// import { $nvcEvent, nvcError, showNC, resetNC } from '../../../utils/nvc'

import gkButton from 'gkui/button'
import gkForm from 'gkui/form/Form'

import CellPhone from '../../gk.form/Cellphone'
import Captcha from '../../gk.form/Captcha'
import ImgCaptcha from '../../gk.form/ImgCaptcha'
import Password from '../../gk.form/Password'

import AccountService from '../../../service/account.service'
import sensorsReport from '../../../utils/sensors.report'
export default {
  name: 'form-login',
  components: {
    gkButton,
    gkForm,
    CellPhone,
    Captcha,
    ImgCaptcha,
    Password
  },
  props: {
    /**
     * 登录类型 [1: 手机号登录   2: 密码登录]
     */
    type: VueTypes.oneOf([1, 2]).def(1),
    theme: VueTypes.oneOf(['blue', 'green']).def('blue')
  },
  data () {
    return {
      signinForm: {},
      isImgCaptchaShow: false,
      mobileValid: true,
      captchaValid: true,
      cellphone: '',
      country: 86,
      captcha: '',
      code: '',
      password: ''
    }
  },
  watch: {
    signinForm (result) {
      this.mobileValid = this.cellphone && result.cellphone && result.cellphone.valid
      this.captchaValid = this.captcha && result.captcha && result.captcha.valid
    }
  },
  computed: {
    isPC () {
      return utils.isPC()
    },
    isInWeixin () {
      return utils.isInWeixin()
    },
    /**
     * 图形验证码的图片url
     */
    imgCaptchaUrl () {
      let map = {
        1: '//account.infoq.cn/account/captcha/smslogin',
        2: '//account.infoq.cn/account/captcha/ticket'
      }
      return map[this.type]
    }
  },
  created () {
    if (JSON.stringify(utils.storage.get('tel')) !== '{}') {
      this.cellphone = utils.storage.get('tel')
    }
  },
  mounted () {
    // $nvcEvent.on('login', (nvcData) => {
    //   this.submit({}, nvcData)
    // })
  },
  methods: {
    handleChooseCountry (country) {
      const validate = this.signinForm.cellphone
      const cellphoneCtrl = this.$refs.signinForm.validitys['cellphone-']

      this.country = country

      if (validate.touched && validate.valid && cellphoneCtrl) {
        cellphoneCtrl.reset()
        cellphoneCtrl.validate()
      }
    },
    handleForgot () {
      utils.jumpUrl(`${config.account}/infoq/forgot?mobile=${this.cellphone}`)
    },
    /**
     * 验证验证码
     */
    handleCheckCaptcha (value, {resolve, reject}) {
      let checkType = this.type === 1 ? 'sms' : 'password'

      AccountService.checkCaptcha(checkType, value).then(res => {
        resolve()
      }).catch(err => {
        const errorCode = signinError.captcha

        reject(err.api === 1 && errorCode[err.code])
      })
    },
    sendMobileCode ({resolve, reject}) {
      if (!this.cellphone) {
        this.$refs.signinForm.invalid('cellphone', '请输入手机号')
        reject({cellphone: this.cellphone})
        return
      }

      if (this.isImgCaptchaShow && !this.captcha) {
        reject()

        return
      }

      return AccountService.sendSmsCode({
        country: this.country,
        cellphone: this.cellphone,
        captcha: this.captcha
        // data: nvcData
      }).then(() => {
        sensorsReport.pushCode('', {current_scene: 'InfoQ 登录'})
        resolve()
      }).catch(err => {
        const errorCode = signinError
        const code = err.code + ''

        // if (nvcError(code, 'sendSms', this)) {
        //   showNC && showNC()

        //   reject()

        //   return
        // }

        // 需要图片验证码
        if (errorCode.captcha[code]) {
          this.isImgCaptchaShow = true
          sensorsReport.pushCode(errorCode.captcha[code], {current_scene: 'InfoQ 登录'})
          reject()
          return
        }

        this.$nextTick(() => {
          Object.keys(errorCode).forEach(key => {
            if (errorCode[key][err.code]) {
              sensorsReport.pushCode(errorCode.captcha[code], {current_scene: 'InfoQ 登录'})
              this.$refs.signinForm.invalid(key, errorCode[key][err.code])
            }
          })
        })

        reject()
      })
    },
    submit ({clear}) {
      let methodsMap = {
        1: AccountService.smslogin,
        2: AccountService.signin
      }

      let method = methodsMap[this.type]

      this.$refs.signinForm.validate().then(({formData}) => {
        method(formData).then(res => {
          // resetNC()

          utils.syncGeekbang(res.oss_token).then(() => {
            this.$emit('success')
            // if (res.type === 'register') {
            // // 如果是新注册用户走后边流程
            //   this.$emit('registerSuccess')
            // } else {
            //   this.$emit('success')
            // }
          })
        }).catch(err => {
          if (err.api === 1) {
            const errorCode = signinError
            const code = err.code + ''

            // if (nvcError(code, 'login', this)) {
            //   showNC && showNC()
            //   return
            // }

            // 需要图片验证码
            if (errorCode.captcha[code]) {
              this.isImgCaptchaShow = true
            }

            Object.keys(errorCode).forEach(key => {
              if (errorCode[key][code]) {
                this.$refs.signinForm.invalid(key, errorCode[key][code])
              }
            })
          }

          clear && clear()
        })
      }).catch((err) => {
        console.log(err)
        clear && clear()
      })
    },
    wechatlogin () {
      this.$emit('wechat', 'wechat')
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/_common";

.form-login {
  & ::v-deep {
    [gk-button][gkbtn-size="large"] {
      height: 48px;

      @include mobile () {
        height: 44px;
      }
    }

    .gkui-form-element-text[gktext-color="underline"] {
      height: 42px;
      margin-bottom: 32px;

      @include mobile () {
        margin-bottom: 22px;
      }

      & [gk-form-element-error] {
        bottom: -26px;
        font-size: 14px;
        color: #DF4C34;

        @include mobile () {
          bottom: -22px;
          font-size: 12px;
        }
      }

      & [gk-form-element-tips] {
        top: -24px;
        @include lineFont(14, 400);
        color: #17B04B;

        @include mobile () {
          font-size: 12px;
        }
      }
    }
  }

  & .btns {
    position: relative;
    margin-top: 38px;

    @include mobile () {
      margin-top: 33px;
    }

    & .forgot {
      position: absolute; top: -32px; right: 0;
      @include lineFont(14, 400);
      color: $gray;
      opacity: 0.6;
      cursor: pointer;

      @include mobile () {
        top: -28px;
        font-size: 14px;
      }
    }

    & p {
      margin: 14px 0;
      text-align: center;
      @include lineFont(16, 400);
      color: $gray;
    }

    & .wechat-btn {
      border: 1px solid $borderGray;
      color: $lightBlack;

      & .iconfont {
        display: inline-block;
        margin-right: 7px;
        font-size: 20px;
        color: #45BE1A;
      }

      @include web () {
        &:hover {
          background: #F8F9FA;
        }
      }
    }
  }
}
</style>
